import script from "./ClubPageMembersTableRepre.vue?vue&type=script&setup=true&lang=js"
export * from "./ClubPageMembersTableRepre.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__